import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { IconBrandProps } from '@uhg-abyss/web/ui/IconBrand/IconBrand';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { ComponentProps } from 'react';

type IFlexProps = ComponentProps<typeof Flex>;
type IIconBrandProps = ComponentProps<typeof IconBrand>;
type IIconSymbolProps = ComponentProps<typeof IconSymbol>;

export interface ICircleBackgroundProps {
  fill: string;
  radius: number;
}

export interface ISquareBackgroundProps {
  fill: string;
  size: number;
  borderRadius?: number;
}

export enum IconName {
  clinicInCircle = 'clinicInCircle',
  clipboardInSquare = 'clipboard',
  costInSquare = 'cost',
  giftInInvertedCircle = 'giftInInvertedCircle',
  heartInCircle = 'heartInCircle',
  lightBulbInSquare = 'lightBulb',
  stethoscopeInCircle = 'stethoscopeInCircle',
  syringeInCircle = 'syringeInCircle',
  stethoscope = 'stethoscope',
  brain = 'brain',
  beaker = 'beaker',
  tooth = 'tooth',
  eye = 'eye',
  clinicLightCircle = 'clinicLightCircle',
  networkDarkCircle = 'networkDarkCircle',
  networkLightCircle = 'networkLightCircle',
  magnifyingGlassDarkCircle = 'magnifyingGlass',
  Practitioner = 'Practitioner',
  Organization = 'Organization',
  'Medical Group' = 'Medical Group',
  'Provider groups' = 'Provider groups',
  mental_health = 'mental_health',
  network_circle = 'network_circle',
  network = 'network',
  clinic = 'clinic',
  UrgentCareClinic = 'UrgentCareClinic',
  quickCarePrimaryCare = 'quickCarePrimaryCare',
  commonSearchStethoscope = 'commonSearchStethoscope',
  care = 'care',
  crutches = 'crutches',
  syringe = 'syringe',
  tube = 'tube',
  treadmill = 'treadmill',
  chiropractor = 'chiropractor',
  commonSearchMentalHealth = 'commonSearchMentalHealth',
  suicideAndCrisisLifelineIcon = 'suicideAndCrisisLifelineIcon',
  substanceUseIcon = 'substanceUseIcon',
  emergencyServicesIcon = 'emergencyServicesIcon',
  tablet = 'tablet',
  phone = 'phone',
}

export interface IOffsetOverrides {
  top?: number;
  left?: number;
}

export interface IIconMappingNode {
  iconBrandProps: IIconBrandProps;
  iconSymbolProps: IIconSymbolProps & { backgroundShape?: 'circle' | 'square' };
  iconSymbolOffsetOverrides?: IOffsetOverrides;
  backgroundColor?: string;
}

export interface IIconBrandAndSymbolProps
  extends Omit<IconBrandProps, 'size' | 'icon'> {
  'data-auto-testid'?: string;
  'data-testid'?: string;
  children?: React.ReactNode;
  icon: IconName;
  size: number;
  isCareCard?: boolean;
  isCobrandedBenefitCard?: boolean;
}

export interface ISquareContainerProps extends IFlexProps {
  size: number;
}
